class ProductCallouts extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.checkboxes = [...this.querySelectorAll('input[type="checkbox"]')];
    this.infoEls = [...this.querySelectorAll('.product-callout-info')];

    this.checkboxes.map((checkboxEl) => {
      checkboxEl.addEventListener('click', this.handleCheckboxClick);
      checkboxEl.addEventListener('keydown', (e) => (this.a11yClick(e) ? e.target.click() : null));
    });
  }

  disconnectedCallback() {
    this.checkboxes.map((checkboxEl) => {
      checkboxEl.removeEventListener('click', this.handleCheckboxClick);
    });
  }

  a11yClick = (e) => {
    return e.key === 'Enter' || e.key === 'enter' || e.key === 'Return' || e.key == 'return';
  };

  uncheckAllCheckboxes = (e) => {
    this.checkboxes.map((checkboxEl) => (checkboxEl !== e.target ? (checkboxEl.checked = false) : null));
  };

  handleInfoVisibility = (foundInfoEl) => {
    this.infoEls.map((infoEl) => {
      if (infoEl === foundInfoEl) {
        foundInfoEl.classList.toggle('visible');
      } else {
        infoEl.classList.remove('visible');
      }
    });
  };

  handleCheckboxClick = (e) => {
    const calloutHandle = e.target.closest('.product-callout').dataset.calloutHandle;
    const foundInfoEl = this.infoEls.filter((description) => description.dataset.calloutHandle === calloutHandle)[0];
    this.uncheckAllCheckboxes(e);
    this.handleInfoVisibility(foundInfoEl);
  };
}

customElements.define('product-callouts', ProductCallouts);
